module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/app/app.component.html
// module id = ../../../../../src/app/app/app.component.html
// module chunks = main